module.exports = __webpack_public_path__ + "static/media/20.938f1cfa.jpg";